//router
import { RouterProvider } from 'react-router-dom';
import { routerConfig } from './router/router';
//localization
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/sr';
import 'dayjs/locale/en';
//components
import CustomPopup from '@components/Popup/CustomPopup';
//style
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import './app.css';
import '@styles/components/globals.scss';
//recoil
import { useRecoilValue } from 'recoil';
import { popupAtom } from '@atoms/popupAtom';
//

function App() {
  const popup = useRecoilValue(popupAtom);
  const lng = localStorage.getItem('lng');
  dayjs.locale(lng === 'sr' ? 'sr' : 'en');

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={lng === 'en' ? 'en' : 'sr'}>
      <ThemeProvider theme={theme}>
        {popup.open && popup.title && <CustomPopup />}
        <RouterProvider router={routerConfig} />
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
